import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";
import "../css/User.css";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import ic_no_data from "../img/ic_no_data.svg";
import "../css/toggle_switch.css";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ic_user from "../img/ic_user.png";
import UserRightsSetting from "./UserRightsSetting";

function LocationRightsSetting() {
  // const COMPANY_CODE = localStorage.getItem("companyCode");
  const [updatedDepartmentRights, setUpdatedDepartmentRights] = useState(null);
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const {
    data: datagetgetLocationList,
    loading: loadinggetLocationList,
    error: errorgetLocationList,
    get: getLocationList,
  } = useApi();
  const {
    data: datapostUpdateDepartmentRights,
    loading: loadingpostUpdateDepartmentRights,
    error: errorpostUpdateDepartmentRights,
    post: postUpdateDepartmentRights,
  } = useApi();

  const query = new URLSearchParams(useLocation().search);

  const user_name = query.get("user_name");

  const handleChangeSwitch = (codeFromClick, valueFromSwitch) => {
    setUpdatedDepartmentRights((prev) =>
      prev?.map((itemURights) => {
        if (itemURights.loc_code === codeFromClick) {
          return {
            ...itemURights,
            AccessStatus: valueFromSwitch === "T" ? "F" : "T",
          };
        }
        return itemURights;
      }),
    );
  };

  useEffect(() => {
    getLocationList(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/LOCACCESSUSER/${encodeURIComponent(user_name)}/-`,
    );
  }, []);

  useEffect(() => {
    setUpdatedDepartmentRights(datagetgetLocationList);
  }, [datagetgetLocationList]);

  useEffect(() => {
    if (datapostUpdateDepartmentRights) {
      if (
        datapostUpdateDepartmentRights?.result?.trim()?.toUpperCase() === "SAVED"
      ) {
        alert("Updated Location rights");
      }
    }
  }, [datapostUpdateDepartmentRights]);

  const saveDepartmentRights = () => {
    let arraytoPass = updatedDepartmentRights
      ?.filter((itemFil) => itemFil.AccessStatus === "T")
      ?.map((item) => {
        return {
          CMPCODE: COMPANY_CODE,
          MODE: "LOCACCESS",
          username: user_name,
          loc_code: item.loc_code,
          loc_order: item.loc_order ? item.loc_order : "1",
          LOC_DESC: item.Description,
        };
      });

    let serialize = JSON.stringify(arraytoPass);

    console.log("arraytoPass>>. ", arraytoPass);

    postUpdateDepartmentRights(
      `https://cubixweberp.com:213/api/CRMLocAccessUser`,
      serialize,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  };

  return (
    <div>
      <div>
        <div className="p-4">
          <h4>Location Access</h4>
          {datagetgetLocationList && (
            <button
              className="bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4"
              onClick={() => saveDepartmentRights()}
            >
              Update Location Rights
            </button>
          )}
        </div>

        <>
          {datagetgetLocationList?.length === 0 &&
          loadinggetLocationList === false ? (
            <div className="p-4">
              <img style={{ width: "100px" }} src={ic_no_data}></img>{" "}
              <p className="mt-3">No data found</p>
            </div>
          ) : (
            <div
              class="overflow-x-auto mt-2"
              style={{ height: "50vh", overflowY: "scroll" }}
            >
              <table
                class="min-w-full divide-y divide-gray-200 border border-gray-300"
                style={{ "border-collapse": "collapse" }}
              >
                <thead>
                  <tr
                    class="bg-gray-100"
                    style={{ position: "sticky", top: "0px", zIndex: 3 }}
                  >
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Has Access
                    </th>
                    {/* <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                                    Code
                                                </th> */}
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Location Code
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Description
                    </th>
                    {/* <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                                    Module
                                                </th>  */}
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  {updatedDepartmentRights?.map((item) => {
                    return (
                      <tr key={item.loc_code} class="hover:bg-gray-50">
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {
                            <FormControlLabel
                              onChange={(e) =>
                                handleChangeSwitch(
                                  item.loc_code,
                                  item.AccessStatus,
                                )
                              }
                              control={
                                <Switch checked={item.AccessStatus === "T"} />
                              }
                              label={item.AccessStatus === "T" ? "On" : "Off"} // Dynamic label based on state onChange={handleChange}
                            />
                          }
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {item.loc_code}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {item.Description}
                        </td>
                        {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.module}</td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      </div>
    </div>
  );
}

export default LocationRightsSetting;
